// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ModuleDeadline {
  deadline: number;
}

export interface ItemDeadline {
  deadline: number;
}

export interface DegreeSession {
  degreeId: string;
}

export interface SessionTypeMetadataDegreeSession {
  typeName: 'degreeSession';
  definition: DegreeSession;
}

export interface CredentialTrackSession {
  degreeId: string;
}

export interface SessionTypeMetadataCredentialTrackSession {
  typeName: 'credentialTrackSession';
  definition: CredentialTrackSession;
}

export type SessionTypeMetadata = SessionTypeMetadataDegreeSession | SessionTypeMetadataCredentialTrackSession;

export type SessionTypeMetadataTypeName = 'degreeSession' | 'credentialTrackSession';

export interface TimedItemLock {
  unlockTime?: number | null;
  relockTime?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ScheduleOverride {
  timedItemLocks: Record<string, TimedItemLock>;
}

export interface OnDemandCourseSessionsV1 {
  id: string;
  courseId: string;
  versionedBranchId?: string | null;
  courseBranchId?: string | null;
  startsAt: number;
  endsAt: number;
  deletedAt?: number | null;
  enrollmentEndsAt: number;
  moduleDeadlines: Record<string, ModuleDeadline>;
  itemDeadlines: Record<string, ItemDeadline>;
  isPrivate: boolean;
  isPreview: boolean;
  discussionSessionId?: string | null;
  sessionTypeMetadata?: SessionTypeMetadata | null;
  scheduleOverride?: ScheduleOverride | null;
  isExternallyManaged: boolean;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface OnDemandCourseSessionsV1Connection {
  elements: Array<OnDemandCourseSessionsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface OnDemandCourseSessionsV1AllByCourseAndStartAtRangeQuery {
  OnDemandCourseSessionsV1: {
    allByCourseAndStartAtRange: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1AllByCourseAndStartAtRangeQueryVariables {
  courseId: string;
  fromStartedAt: string;
  toStartedAt: string;
  includeExternallyManaged?: string | null;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1BranchQuery {
  OnDemandCourseSessionsV1: {
    branch: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1BranchQueryVariables {
  courseBranchId: string;
  onlyIncludeActiveSessions: string;
  includeExternallyManaged?: string | null;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1CourseQuery {
  OnDemandCourseSessionsV1: {
    course: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1CourseQueryVariables {
  courseId: string;
  includeExternallyManaged?: string | null;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1DeleteQuery {
  OnDemandCourseSessionsV1: {
    delete: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1EarliestOpenSessionByCourseQuery {
  OnDemandCourseSessionsV1: {
    earliestOpenSessionByCourse: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1EarliestOpenSessionByCourseQueryVariables {
  courseId: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1GetQuery {
  OnDemandCourseSessionsV1: {
    get: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1GetAllQuery {
  OnDemandCourseSessionsV1: {
    getAll: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1GetAllQueryVariables {
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1MultiGetQuery {
  OnDemandCourseSessionsV1: {
    multiGet: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface OnDemandCourseSessionsV1CreateMutation {
  OnDemandCourseSessionsV1: {
    create: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1CreateMutationVariables {
  skipCourseSessionErrorsCheck?: string | null;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1HardDeleteMutation {
  OnDemandCourseSessionsV1: {
    hardDelete: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1HardDeleteMutationVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1RevertSoftDeleteMutation {
  OnDemandCourseSessionsV1: {
    revertSoftDelete: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1RevertSoftDeleteMutationVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1SyncSessionDeadlinesWithCourseMaterialMutation {
  OnDemandCourseSessionsV1: {
    syncSessionDeadlinesWithCourseMaterial: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1SyncSessionDeadlinesWithCourseMaterialMutationVariables {
  versionedCourseBranchId: string;
  includes?: string | null;
}

export interface OnDemandCourseSessionsV1UpdateMutation {
  OnDemandCourseSessionsV1: {
    update: OnDemandCourseSessionsV1Connection | null;
  } | null;
}

export interface OnDemandCourseSessionsV1UpdateMutationVariables {
  id: string;
  allowTimeChanges?: string | null;
  allowBranchChanges?: string | null;
  allowChangingExternallyManagedFlag?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class OnDemandCourseSessionsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandCourseSessions.v1' as const;

  declare id: string;

  declare courseId: string;

  declare versionedBranchId?: string | null;

  declare courseBranchId?: string | null;

  declare startsAt: number;

  declare endsAt: number;

  declare deletedAt?: number | null;

  declare enrollmentEndsAt: number;

  declare moduleDeadlines: Record<string, ModuleDeadline>;

  declare itemDeadlines: Record<string, ItemDeadline>;

  declare isPrivate: boolean;

  declare isPreview: boolean;

  declare discussionSessionId?: string | null;

  declare sessionTypeMetadata?: SessionTypeMetadata | null;

  declare scheduleOverride?: ScheduleOverride | null;

  declare isExternallyManaged: boolean;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<OnDemandCourseSessionsV1>) {
    super(params);
  }
}
